"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var index_1 = require("@uifabric/styling/lib/index");
index_1.registerIconAlias('trash', 'delete');
//# sourceMappingURL=icon-aliases.js.map


//////////////////
// WEBPACK FOOTER
// ../~/@uifabric/icons/lib/icon-aliases.js
// module id = ../node_modules/@uifabric/icons/lib/icon-aliases.js
// module chunks = 1